import React, { useEffect, useState } from 'react';
import Icon from '@/components/Icon';
import { ApiError, api } from '@/lib/api';

function fmtDateRu(iso) {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  return `${d}.${m}.${y}`;
}

export default function LessonInfoModal({ editing, onClose, onSaved }) {
  const [theme, setTheme]       = useState(editing.theme || '');
  const [homework, setHomework] = useState(editing.homework || '');
  const [comment, setComment]   = useState(editing.comment || '');
  const [saving, setSaving]     = useState(false);
  const [error, setError]       = useState(null);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape' && !saving) onClose(); };
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose, saving]);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true); setError(null);
    try {
      const res = await api.put('/api/journal/lesson', {
        scheduleLessonId: editing.scheduleLessonId,
        date: editing.date,
        theme, homework, comment,
      });
      onSaved?.(res.lesson);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : (err.message || 'Не удалось сохранить'));
    } finally { setSaving(false); }
  };

  return (
    <div className="sd-overlay" onClick={(e) => { if (e.target.classList.contains('sd-overlay') && !saving) onClose(); }}>
      <div className="sd-modal sd-modal--medium" role="dialog" aria-modal="true">
        <div className="sd-edit__head">
          <h2>
            Урок {editing.position} · {fmtDateRu(editing.date)}
          </h2>
          <button className="sd-close" onClick={onClose} disabled={saving}><Icon name="x" size={14} /></button>
        </div>
        <form onSubmit={submit} className="sd-edit__form" noValidate>
          <div className="sd-edit__body">
            <div className="sd-edit__field sd-edit__field--full">
              <label className="sd-edit__label">Тема урока</label>
              <textarea
                className="sd-edit__input"
                rows={3}
                value={theme}
                onChange={(e) => setTheme(e.target.value)}
                placeholder="Например: «Сложение в пределах 100»"
                autoFocus
              />
            </div>
            <div className="sd-edit__field sd-edit__field--full">
              <label className="sd-edit__label">Домашнее задание</label>
              <textarea
                className="sd-edit__input"
                rows={3}
                value={homework}
                onChange={(e) => setHomework(e.target.value)}
                placeholder="№ 12, 14, выучить правило"
              />
            </div>
            <div className="sd-edit__field sd-edit__field--full">
              <label className="sd-edit__label">Комментарий учителя</label>
              <textarea
                className="sd-edit__input"
                rows={2}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Внутренние пометки, не показываются ученикам"
              />
            </div>
          </div>
          <div className="sd-edit__foot">
            {error && <div className="sd-edit__error">{error}</div>}
            <div className="sd-edit__foot-spacer" />
            <button type="button" className="btn btn--sm" onClick={onClose} disabled={saving}>Отмена</button>
            <button type="submit" className="btn btn--primary btn--sm" disabled={saving}>
              {saving ? 'Сохраняем…' : 'Сохранить'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
